module.exports = __webpack_public_path__ + "img/mood_okay.f54a148a.svg";